import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { IFetchClientAddressResult } from "./types";
import { serverResponse } from "./validators";

export async function fetchClientAddress(): Promise<IFetchClientAddressResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/users/addresses?type=RESIDENTIAL`,
    {
      headers: {
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
      validator: serverResponse,
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
